import { RestaurantInfoDirective } from './restaurantInfo.directive';

import { ConsumerService } from './consumer.service';
import { GoogleAnalyticsService } from './googleAnalytics.service';
import { LocationService } from './location.service';
import { RestaurantService } from './restaurant.service';

import { FloatRoundingFilter } from './floatRoundingFilter/floatRounding.filter';
import { DiningOptionDisplayFilter } from './diningOptionDisplayFilter/diningOptionDisplay.filter';

export const SharedModule = angular.module('oo.multilocation.picker.shared', [])
    .directive('restaurantInfo', RestaurantInfoDirective)

    .factory('consumerService', ConsumerService)
    .factory('googleAnalyticsService', GoogleAnalyticsService)
    .factory('locationService', LocationService)
    .factory('restaurantService', RestaurantService)

    .filter('floatRoundingFilter', FloatRoundingFilter)
    .filter('diningOptionDisplayFilter', DiningOptionDisplayFilter)
    .name;
